module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_EL-2d561d4df52ea6a26ada3313c1039359.svg";